import React from 'react';
import NextApp from 'next/app';
import { setAppElement } from 'react-modal';
import Script from 'next/script';
import { OllieTheme, GlobalStyle } from '@ui/theme';
import { ExperimentProvider } from '../experiments/index';
import {
  Reporter,
  ReporterProvider,
  ElevarReporter,
  ElevarReporterProvider,
} from '../reporter';
import { ToastProvider } from '../Toast/ToastProvider';
import { OfferProvider, ShopifyOfferProvider } from '../offer';
import { ShopifyCartProvider } from '../onboarding/OnboardingFlowContainer/ShopifyCartProvider';
import { SamplerCartProvider } from '../onboarding/SamplerBoxFlowContainer/SamplerCartProvider';
import { CampaignProvider } from '../campaign';
import { ApiProvider } from '../api';
import { ShopifyAuthProvider } from '../auth/ShopifyAuth';
import { ErrorBoundary } from '../containers/ErrorPage/ErrorBoundary';
import { GladlyContainer } from '../gladly/container';

class App extends NextApp {
  reporter = new Reporter();
  elevarReporter = new ElevarReporter();

  static async getInitialProps(arg) {
    // Opting out of ASO to get runtime env config on every page.
    // Yes, this isn't great, but injecting the env vars at buildtime
    // isn't possible in a docker world.
    // TODO(James) remove this... somehow.
    // Hey, if I had a plan, I wouldn't have wrote this in the first place.
    return super.getInitialProps(arg);
  }

  componentDidCatch(error, errorInfo) {
    this.reporter.error(error, { contexts: errorInfo });
  }

  componentDidMount() {
    setAppElement('#__next');
  }

  render() {
    const { Component, pageProps } = this.props;

    return (
      <ApiProvider initialSession={pageProps.session}>
        <ShopifyAuthProvider initialSession={pageProps.session}>
          <CampaignProvider>
            <ReporterProvider reporter={this.reporter}>
              <ElevarReporterProvider elevarReporter={this.elevarReporter}>
                <OllieTheme>
                  <ToastProvider>
                    <ShopifyCartProvider>
                      <SamplerCartProvider>
                        <OfferProvider>
                          <ShopifyOfferProvider>
                            <ExperimentProvider
                              flagshipData={pageProps.flagshipData}
                            >
                              <GlobalStyle />
                              <ErrorBoundary reporter={this.reporter}>
                                <Component {...pageProps} />
                              </ErrorBoundary>
                              <GladlyContainer
                                gladlySettings={pageProps.gladly}
                              />
                              <Script src="https://www.googletagmanager.com/gtag/js?id=G-H1JV5JVL6B" />
                              <Script id="google-analytics">
                                {`
                        window.dataLayer = window.dataLayer || [];
                        function gtag(){dataLayer.push(arguments);}
                        gtag('js', new Date());

                        gtag('config', 'G-H1JV5JVL6B');
                      `}
                              </Script>
                            </ExperimentProvider>
                          </ShopifyOfferProvider>
                        </OfferProvider>
                      </SamplerCartProvider>
                    </ShopifyCartProvider>
                  </ToastProvider>
                </OllieTheme>
              </ElevarReporterProvider>
            </ReporterProvider>
          </CampaignProvider>
        </ShopifyAuthProvider>
      </ApiProvider>
    );
  }
}

export default App;
